import React from 'react';

import styles from './styles.module.scss';

import ImageBackground from '@components/_shared/imageBackground';
import { ListOnRoveLandingType } from '@utils/types/landings';
import ContactForm from '@components/landing/_shared/contactForm';
import ImageWithLoader from '@components/_shared/imageWithLoader';
import Button from '@components/_shared/button';

const ListOnRoveHero = (
  props: Pick<
    ListOnRoveLandingType,
    | 'title'
    | 'subtitle'
    | 'businessInsiderReview'
    | 'inmanReview'
    | 'newYorkWeeklyReview'
    | 'contact'
  > & { cta: ListOnRoveLandingType['advantage']['cta'] }
) => {
  const {
    title,
    subtitle,
    contact,
    businessInsiderReview,
    inmanReview,
    newYorkWeeklyReview,
    cta,
  } = props;

  const onGetStartedClick = () => {
    const container = document.getElementById('contact');
    window.scrollTo({
      top: (container?.offsetTop || 200) - 200,
      behavior: 'smooth',
    });
  };

  return (
    <ImageBackground
      containerStyle={styles.hero}
      backgroundImageStyle={`
        url('/images/list-on-rove-hero-bg.png')
      `}
    >
      <div className={styles.hero__wrapper}>
        <div className={styles.hero__textBlock}>
          <h1 className={styles.hero__title}>{title}</h1>
          <div className={styles.hero__subtitle}>{subtitle}</div>
        </div>

        <ContactForm
          formTitle={contact.heroFormTitle}
          cta={contact.cta}
          containerStyle={styles.hero__contactForm}
        />

        <Button
          onClick={onGetStartedClick}
          containerStyle={styles.hero__mobileCta}
          variant="greenContained"
        >
          {cta}
        </Button>
      </div>

      <div className={styles.hero__pressItems}>
        <div className={styles.hero__pressItem}>
          <div className={styles.hero__pressItemText}>
            {businessInsiderReview}
          </div>

          <ImageWithLoader
            layout="fixed"
            width={213}
            height={19}
            src="/images/business-insider.svg"
            alt="business insider"
            quality={100}
          />
        </div>

        <div className={styles.hero__pressItem}>
          <div className={styles.hero__pressItemText}>{inmanReview}</div>

          <ImageWithLoader
            layout="fixed"
            width={114}
            height={26}
            src="/images/inman.svg"
            alt="inman"
            quality={100}
          />
        </div>

        <div className={styles.hero__pressItem}>
          <div className={styles.hero__pressItemText}>
            {newYorkWeeklyReview}
          </div>

          <ImageWithLoader
            layout="fixed"
            width={200}
            height={24}
            src="/images/new-york-weekly.svg"
            alt="new york weekly"
            quality={100}
          />
        </div>
      </div>
    </ImageBackground>
  );
};

export default ListOnRoveHero;
